import {Nullable, PageInfoType, ReviewMediaType} from "../../definitions/types";
import {ReviewMediaModel} from "../domain/reviewMediaModel";
import {PageInfoModel} from "../domain/pageInfoModel";
import {reviewMediaDefaultPageSize} from "../../utils/constants";

export class MediaModel {
    private readonly _pageInfo: PageInfoModel;
    private readonly _media: ReviewMediaModel[];

    constructor(public readonly connection: Nullable<{ media: Nullable<ReviewMediaType>[], pageInfo: PageInfoType }>) {
        this._pageInfo = new PageInfoModel(connection?.pageInfo);
        this._media = (connection?.media ?? [])
            .filter((medium): medium is ReviewMediaType => medium !== null)
            .map((reviewMedia) => new ReviewMediaModel(reviewMedia));
    }

    /**
     * @method pageInfo
     * @description Returns the page info of the media connection.
     * @returns {PageInfoModel}
     */
    public get pageInfo(): PageInfoModel {
        return this._pageInfo;
    }

    /**
     * @method media
     * @description Returns the media of the media connection.
     * @returns {ReviewMediaModel[]}
     */
    public get media(): ReviewMediaModel[] {
        return this._media;
    }

    /**
     * @method visibleMedia
     * @description Returns the visible media of the media connection.
     * @returns {ReviewMediaModel[]}
     */
    public get visibleMedia(): ReviewMediaModel[] {
        return this._media.filter((medium) => medium.visible);
    }

    /**
     * @method mediaPreview
     * @description Returns the media preview of the media connection.
     * @returns {ReviewMediaModel[]}
     */
    public get mediaPreview(): ReviewMediaModel[] {
        return this.visibleMedia.slice(0, reviewMediaDefaultPageSize);
    }
}